import * as tslib_1 from "tslib";
// Third party packages
import { EMPTY, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
// Custom packages
import { CookieService } from "ngx-cookie-service";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "ngx-cookie-service";
var CompaniesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CompaniesService(apiService, helperService, cookieService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.cookieService = cookieService;
    }
    /**
     * Create a new company
     *
     * @since 1.0.0
     *
     * @param company Company data
     */
    CompaniesService.prototype.create = function (company) {
        return this.apiService.apiCall("POST", "companies", company);
    };
    /**
     * Add a subUser to company subUsers
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.createSubUser = function (companyId, subUser) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/sub-users", subUser);
    };
    /**
     * Add a subProperty to company subProperties
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.createSubProperty = function (companyId, subProperty) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/sub-properties", subProperty);
    };
    /**
     * Add a doc to company
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.createDoc = function (companyId, doc) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/documents", doc);
    };
    /**
     * Add a new folder
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.createFolder = function (companyId, doc) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/new-folder", doc);
    };
    /**
     * Add a contact to company phonebook
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.createPhonebookContact = function (companyId, phonebookContact) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/phonebook", phonebookContact);
    };
    /**
     * Import contacts to company phonebook
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.importPhonebookContact = function (companyId, phonebookContact) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/phonebook/import", phonebookContact);
    };
    /**
     * Get given companyId data from back-end
     *
     * @since 1.0.0
     *
     * @param companyId ID of the company to get
     */
    CompaniesService.prototype.get = function (companyId) {
        var _this = this;
        return this.apiService.apiCall("GET", "companies/" + companyId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given companyId data from back-end
     *
     * @since 1.0.0
     *
     * @param companyId ID of the company to get
     */
    CompaniesService.prototype.getBaseData = function (companyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/" + companyId + "/base-data")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given companyId BiPy subscription status
     *
     * @since 1.0.0
     *
     * @param companyId ID of the company to get
     */
    CompaniesService.prototype.getBipyStatus = function (companyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/" + companyId + "/bipy-status")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get all companies with subscription suppliers
     *
     * @since 1.0.0
     *
     */
    CompaniesService.prototype.getSuppliersActive = function () {
        var _this = this;
        return this.apiService.apiCall("GET", "companies/suppliers-active").pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get companies list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        if (!sort) {
            sort = "name";
            sortVersus = "asc";
        }
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies", params);
    };
    /**
     * Get companies list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getListAll = function (start, limit, sort, sortVersus, search) {
        if (!sort) {
            sort = "name";
            sortVersus = "asc";
        }
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies/list-all", params);
    };
    /**
     * Get companies list for given query params (only admin companies)
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getListAdmin = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            search = tslib_1.__assign({}, search, { types: ["manager"] });
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies", params);
    };
    /**
     * Get companies list for given query params (only admin companies)
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getListOwner = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            search = tslib_1.__assign({}, search, { types: ["owner"] });
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies", params);
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.getExport = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/export", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.getExportSuspended = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/export-suspended", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.getExportPhonebook = function (companyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/" + companyId + "/export-phonebook", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.getExportPhonebookAdmin = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/export-phonebook-admin", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get subUsers list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getSubUsersList = function (companyId, start, limit, sort, sortVersus) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        return this.apiService.apiCall("GET", "companies/" + companyId + "/sub-users", params);
    };
    /**
     * Get subProperties list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getSubPropertiesList = function (companyId, start, limit, sort, sortVersus, search, userId) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus, userId: userId };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies/" + companyId + "/sub-properties", params);
    };
    /**
     * Get phonebook list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results numbers
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getPhonebookList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies/" + companyId + "/phonebook", params);
    };
    /**
     * Get phonebook list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results numbers
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getPhonebookListMaster = function (start, limit, sort, sortVersus, search) {
        var companyId = this.cookieService.get("requestedCompany");
        if (!companyId) {
            return EMPTY;
        }
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies/" + companyId + "/phonebook", params);
    };
    /**
     * Get phonebook list for given query params
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results numbers
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getPhonebookListAdmin = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies/phonebook-admin", params);
    };
    /**
     * Get company total docs
     *
     * @since 1.0.0
     *
     * @param
     */
    CompaniesService.prototype.getCompanyTotalDocs = function (companyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "document-archives/company-total-docs", { companyId: companyId })
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    CompaniesService.prototype.getPropertiesWithSupplierAgreement = function (companyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "companies/" + companyId + "/properties-with-supplier-agreement", {})
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get suspended companies list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CompaniesService.prototype.getSuspendedList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "companies/suspended", params);
    };
    /**
     * Get an exportation technical file of company
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.getTechnicalFile = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "companies/" + companyId + "/export-technical-file", {}, undefined, undefined, undefined, 'v2').pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Update company with given companyId with given company data
     *
     * @since 1.0.0
     *
     * @param companyId ID of company to update
     * @param data New company's data
     */
    CompaniesService.prototype.updateDisclaimer = function (companyId, data) {
        return this.apiService.apiCall("PATCH", "companies/" + companyId, data);
    };
    /**
     * Update company with given companyId with given company data
     *
     * @since 1.0.0
     *
     * @param companyId ID of company to update
     * @param data New company's data
     */
    CompaniesService.prototype.updateFields = function (companyId, data) {
        return this.apiService.apiCall("PATCH", "companies/" + companyId + "/fields", data, undefined, undefined, undefined, "v2");
    };
    /**
     * Determine whether the masterCode column should be visible for the
     * given role/company combination. Only master/collaborator roles are
     * gated by the company's showMasterCode setting; every other role
     * always sees the column (unchanged behaviour).
     *
     * @since 3.0.0
     */
    CompaniesService.prototype.shouldShowMasterCodeColumn$ = function (roleType, companyId) {
        if (roleType !== "master" && roleType !== "collaborator") {
            return of(true);
        }
        if (!companyId) {
            return of(false);
        }
        return this.get(companyId).pipe(map(function (res) { return !!(res && res.status && res.data && res.data.showMasterCode); }));
    };
    /**
     * This update supplier number associated to company master
     *
     * @since 1.0.0
     *
     * @param companyId ID of company to update
     */
    CompaniesService.prototype.updateSuppliersNumber = function (companyId) {
        return this.apiService.apiCall("PATCH", "companies/" + companyId + "/update-suppliers-number", {});
    };
    /**
     * Update company with given companyId with given company data
     *
     * @since 1.0.0
     *
     * @param companyId ID of company to update
     * @param data New company's data
     */
    CompaniesService.prototype.update = function (companyId, data) {
        return this.apiService.apiCall("PUT", "companies/" + companyId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Update given subUserId
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.updateSubUser = function (companyId, subUserId, data) {
        var _this = this;
        return this.apiService
            .apiCall("PUT", "companies/" + companyId + "/sub-users/" + subUserId, data)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Toggle given subProperty's activation
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.toggleSubProperty = function (companyId, subPropertyId, data) {
        var _this = this;
        return this.apiService
            .apiCall("PUT", "companies/" + companyId + "/sub-properties/" + subPropertyId, data, { contentType: "auto" })
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update given phonebookContactId
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.updatePhonebookContact = function (companyId, phonebookContactId, data) {
        var _this = this;
        return this.apiService
            .apiCall("PUT", "companies/" + companyId + "/phonebook/" + phonebookContactId, data)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Activate company
     *
     * @since 1.0.0
     *
     * @param companyId ID of the company
     */
    CompaniesService.prototype.activate = function (companyId) {
        return this.apiService.apiCall("POST", "companies/" + companyId + "/activate");
    };
    /**
     * Delete permanently a company
     *
     * @since 1.0.0
     *
     * @param companyId ID of the company
     */
    CompaniesService.prototype.delete = function (companyId) {
        return this.apiService.apiCall("DELETE", "companies/" + companyId);
    };
    /**
     * Delete permanently a company's subUser
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.deleteSubUser = function (companyId, subUserId) {
        return this.apiService.apiCall("DELETE", "companies/" + companyId + "/sub-users/" + subUserId);
    };
    /**
     * Delete permanently a company's subProperty
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.deleteSubProperty = function (companyId, subPropertyId) {
        return this.apiService.apiCall("DELETE", "companies/" + companyId + "/sub-properties/" + subPropertyId);
    };
    /**
     * Delete permanently a company's phonebook
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.deletePhonebookContact = function (companyId, phonebookContactId) {
        return this.apiService.apiCall("DELETE", "companies/" + companyId + "/phonebook/" + phonebookContactId);
    };
    /**
     * Delete permanently a company's document
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.deleteDoc = function (companyId, docId) {
        return this.apiService.apiCall("DELETE", "companies/" + companyId + "/documents/" + docId);
    };
    /**
     * Delete permanently a company's document
     *
     * @since 1.0.0
     */
    CompaniesService.prototype.deleteFolder = function (companyId, pathToDelete) {
        return this.apiService.apiCall("DELETE", "companies/" + companyId + "/delete-folder", { pathToDelete: pathToDelete });
    };
    CompaniesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompaniesService_Factory() { return new CompaniesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.CookieService)); }, token: CompaniesService, providedIn: "root" });
    return CompaniesService;
}());
export { CompaniesService };
